(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Retro Vault product page: smooth gallery, sliding selector, hover zoom, text groups, word cascade */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf = function (fn) { return window.requestAnimationFrame(fn); };

    /* keep the photos on screen while the long info column scrolls */
    function blocked(wrap) {
      var el = wrap.parentElement;
      while (el && el !== document.body && el !== document.documentElement) {
        var cs = getComputedStyle(el);
        if (/(hidden|auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY)) return true;
        el = el.parentElement;
      }
      return false;
    }
    function follow(root) {
      var wrap = root.querySelector('.product__media-wrapper');
      if (!wrap) return;
      var desk = window.matchMedia('(min-width: 990px)');
      var row = wrap.parentElement, pending = 0, on = false;
      function update() {
        pending = 0;
        if (!desk.matches) { wrap.style.transform = ''; return; }
        var r = row.getBoundingClientRect();
        var max = Math.max(0, r.height - wrap.offsetHeight);
        var top = Math.min(96, window.innerHeight - 16 - wrap.offsetHeight);
        wrap.style.transform = 'translate3d(0,' + Math.round(Math.min(max, Math.max(0, top - r.top))) + 'px,0)';
      }
      function req() { if (!pending) pending = raf(update); }
      function enable() { if (on) return; on = true; root.setAttribute('data-rvp-follow', ''); update(); }
      function check() {
        if (on || !desk.matches) return;
        var r = row.getBoundingClientRect(), w = wrap.getBoundingClientRect();
        if (r.top < -80 && r.bottom > window.innerHeight * 0.6 && w.top < -40) enable();
      }
      if (blocked(wrap)) enable();
      window.addEventListener('scroll', function () { if (on) req(); else check(); }, { passive: true });
      window.addEventListener('resize', req, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(req).observe(row);
    }

    /* smooth slide whenever another photo is chosen */
    function slides(root, gal) {
      if (!gal.animate || reduce) return;
      var last = 0, lastIdx = 0, dir = 1;
      function play() {
        var now = Date.now(); if (now - last < 250) return; last = now;
        var el = gal.querySelector('.product__media-item.is-active .product__media') || gal.querySelector('.product__media');
        if (!el) return;
        el.animate([{ opacity: 0, transform: 'translate3d(' + (46 * dir) + 'px,0,0) scale(.985)' }, { opacity: 1, transform: 'translate3d(0,0,0) scale(1)' }],
          { duration: 800, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      gal.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('.thumbnail');
        if (t) { var all = Array.prototype.slice.call(gal.querySelectorAll('.thumbnail')), i = all.indexOf(t); dir = i >= lastIdx ? 1 : -1; lastIdx = i; setTimeout(play, 70); return; }
        var b = e.target.closest && e.target.closest('.slider-button');
        if (b) { dir = b.name === 'previous' ? -1 : 1; setTimeout(play, 90); }
      });
      if (window.MutationObserver) {
        new MutationObserver(function (list) {
          for (var k = 0; k < list.length; k++) {
            var m = list[k];
            if (m.target.classList.contains('is-active') && (m.oldValue || '').indexOf('is-active') === -1) { play(); break; }
          }
        }).observe(gal, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      }
    }

    /* a ring that glides to the selected thumbnail + a "3 / 8" counter */
    function selector(root, gal) {
      var list = gal.querySelector('.thumbnail-list');
      if (!list) return;
      var host = list.closest('slider-component') || list.parentElement;
      var ind = document.createElement('span'); ind.className = 'rvp-ind'; host.appendChild(ind);
      var pill = document.createElement('span'); pill.className = 'rvp-count'; gal.appendChild(pill);
      function current() { return list.querySelector('.thumbnail[aria-current="true"]') || list.querySelector('.thumbnail[aria-current]'); }
      function place() {
        var cur = current(), all = list.querySelectorAll('.thumbnail');
        if (!cur) { ind.style.opacity = 0; return; }
        /* layout position (ignores hover lift / entrance transforms) */
        var x = 0, y = 0, el = cur;
        while (el && el !== host) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
        if (el !== host) { var hr = host.getBoundingClientRect(), r = cur.getBoundingClientRect(); x = r.left - hr.left; y = r.top - hr.top; }
        else { x -= list.scrollLeft; y -= list.scrollTop; }
        ind.style.width = cur.offsetWidth + 'px'; ind.style.height = cur.offsetHeight + 'px';
        ind.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
        ind.style.opacity = 1;
        pill.textContent = (Array.prototype.indexOf.call(all, cur) + 1) + ' / ' + all.length;
        pill.style.display = all.length > 1 ? '' : 'none';
      }
      var t = 0; function soon() { clearTimeout(t); t = setTimeout(place, 16); }
      if (window.MutationObserver) new MutationObserver(soon).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
      list.addEventListener('scroll', soon, { passive: true });
      list.addEventListener('animationend', soon);
      window.addEventListener('resize', soon, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(soon).observe(host);
      place(); setTimeout(place, 600);
    }

    /* hover zoom follows the cursor */
    function zoom(gal) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var pend = 0, ev = null;
      gal.addEventListener('mousemove', function (e) {
        var m = e.target.closest && e.target.closest('.product__media');
        if (!m) return;
        ev = { m: m, x: e.clientX, y: e.clientY };
        if (!pend) pend = raf(function () {
          pend = 0; var r = ev.m.getBoundingClientRect();
          ev.m.style.setProperty('--zx', ((ev.x - r.left) / r.width * 100).toFixed(1) + '%');
          ev.m.style.setProperty('--zy', ((ev.y - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }, { passive: true });
    }

    /* description: find every "label + text" group, whatever markup the product uses */
    function groups(root) {
      var D = root.querySelector('.product__description');
      if (!D || D.dataset.rvpGrouped) return;
      D.dataset.rvpGrouped = '1';
      var host = D;
      while (host.children.length === 1 && !host.textContent.replace(host.children[0].textContent, '').trim()) host = host.children[0];
      var kids = Array.prototype.slice.call(host.children);
      function clean(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
      function isLabel(el) {
        if (/^H[1-6]$/.test(el.tagName)) return true;
        var t = clean(el.textContent);
        if (!t || t.length > 70 || el.tagName === 'UL' || el.tagName === 'OL') return false;
        var inner = el.querySelector('strong, b, span[style*="bold"], span[style*="700"]');
        if (inner && clean(inner.textContent) === t) return true;
        return !el.children.length && parseInt(getComputedStyle(el).fontWeight, 10) >= 600;
      }
      function inlineLabel(el) {
        var f = el.firstElementChild;
        if (!f || !/^(STRONG|B)$/.test(f.tagName) || el.firstChild !== f) return null;
        return clean(el.textContent).length - clean(f.textContent).length > 8 ? f : null;
      }
      var cur = null, found = 0;
      kids.forEach(function (el) {
        var inl = inlineLabel(el);
        if (inl) { el.classList.add('rvp-grp', 'rvp-inline'); inl.classList.add('rvp-lab'); cur = null; found++; return; }
        if (isLabel(el)) {
          cur = document.createElement('div'); cur.className = 'rvp-grp';
          host.insertBefore(cur, el); el.classList.add('rvp-lab'); cur.appendChild(el); found++;
        } else if (cur) { cur.appendChild(el); }
      });
      if (found) D.classList.add('rvp-grouped');
    }

    /* description text: words rise in one after another when it scrolls into view */
    function words(root) {
      var D = root.querySelector('.product__description');
      if (!D) return;
      var targets = Array.prototype.slice.call(D.querySelectorAll('p, li, .rvp-inline')).filter(function (el) { return !el.closest('.rvp-lab') && !el.classList.contains('rvp-lab'); });
      if (!targets.length) return;
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 }) : null;
      targets.forEach(function (p) {
        if (p.dataset.rvpSplit) return;
        p.dataset.rvpSplit = '1';
        var n = 0;
        (function walk(node) {
          Array.prototype.slice.call(node.childNodes).forEach(function (c) {
            if (c.nodeType === 3) {
              if (!c.nodeValue.trim()) return;
              var frag = document.createDocumentFragment();
              c.nodeValue.split(/(\s+)/).forEach(function (part) {
                if (!part) return;
                if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
                var s = document.createElement('span');
                s.className = 'rvp-wd';
                s.style.setProperty('--i', Math.min(n++, 26));
                s.textContent = part;
                frag.appendChild(s);
              });
              c.parentNode.replaceChild(frag, c);
            } else if (c.nodeType === 1 && c.tagName !== 'BR' && !c.classList.contains('rvp-lab')) walk(c);
          });
        })(p);
        if (reduce || !io) p.classList.add('is-in'); else io.observe(p);
      });
      root.classList.add('rvp-js');
    }

    /* speed guard: if this device cannot hold a smooth frame rate, drop the heavy background effects */
    function guard(root) {
      if (root.dataset.rvpAuto !== 'true' || reduce || !window.requestAnimationFrame) return;
      var weak = navigator.deviceMemory && navigator.deviceMemory <= 1;
      if (weak) { root.classList.add('rvp-lite'); return; }
      function sample(done) {
        var deltas = [], last = 0;
        function tick(t) {
          if (document.hidden) { return setTimeout(function () { raf(tick); }, 500); }
          if (last) deltas.push(t - last);
          last = t;
          if (deltas.length < 45) return raf(tick);
          deltas.sort(function (a, b) { return a - b; });
          done(deltas[Math.floor(deltas.length / 2)]);
        }
        raf(tick);
      }
      setTimeout(function () {
        sample(function (m) {
          if (m > 30) { root.classList.add('rvp-lite'); return; }
          setTimeout(function () { sample(function (m2) { if (m2 > 30) root.classList.add('rvp-lite'); }); }, 5000);
        });
      }, 2200);
    }

    function boot() {
      document.querySelectorAll('product-info.rvp').forEach(function (r) {
        if (r.dataset.rvpFx) return;
        r.dataset.rvpFx = '1';
        var gal = r.querySelector('media-gallery');
        follow(r);
        if (gal) { slides(r, gal); selector(r, gal); zoom(gal); }
        groups(r); words(r); guard(r);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    if (!window.__rvpBound) { window.__rvpBound = true; document.addEventListener('shopify:section:load', boot); }
  })();

  } catch(e) { console.error(e); }
})();
})();
